function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.8728 0.060259C23.9991 -0.371716 30.8572 1.43632 33.0227 8.16859C35.447 15.7056 32.7609 24.259 27.1542 28.9154C21.7422 33.4099 14.3027 32.905 9.17499 27.9736C4.77236 23.7396 5.50176 16.2418 7.45563 9.97134C9.15205 4.5271 12.9375 0.408247 17.8728 0.060259Z",
  fill: "#4F71E0",
  fillOpacity: 0.08
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9169 4.33337C9.77076 4.33337 5.58359 8.52054 5.58359 13.6609C5.54976 21.18 14.5623 27.4147 14.9169 27.6667C14.9169 27.6667 24.2841 21.18 24.2503 13.6667C24.2503 8.52054 20.0631 4.33337 14.9169 4.33337ZM14.9169 18.3334C12.3386 18.3334 10.2503 16.245 10.2503 13.6667C10.2503 11.0884 12.3386 9.00004 14.9169 9.00004C17.4953 9.00004 19.5836 11.0884 19.5836 13.6667C19.5836 16.245 17.4953 18.3334 14.9169 18.3334Z",
  fill: "#060238"
});

var SvgMaps = function SvgMaps(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaps, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maps.0c301fb1.svg";
export { ForwardRef as ReactComponent };